import isString from 'lodash/isString';
import moment from 'moment-timezone';

/**
 * Utility methods for use throughout our code base.
 * @module SHUtils
 */
const SHUtils = {
    prettyPrice(price, format) {
        let prettyPrice = price;

        if (isString(prettyPrice)) {
            prettyPrice = parseInt(prettyPrice, 10);
        }

        if (!format && prettyPrice.toFixed(2).split('.')[1] === '00') {
            return prettyPrice;
        } else {
            return prettyPrice.toFixed(2);
        }
    },

    /**
     * Outputs SpotHero standard formatted time duration string from milliseconds.
     * @param {Object} duration - Difference between two times in milliseconds
     * @param {Object} hoursOnly - Returns a string with hour total only
     * @example
     * SHUtils.prettyDuration(100000);
     * SHUtils.prettyDuration(momentEndDate.diff(momentStartDate));
     * @returns {String} SpotHero standard formatted time duration string (i.e. "3 days, 12 hours, 30 minutes")
     */
    prettyDuration(duration, hoursOnly) {
        let formattedDuration = moment.duration(duration);

        if (hoursOnly) {
            formattedDuration = formattedDuration
                .format('h m [min]')
                .replace(' 30 min', '.5')
                .replace('30 min', '.5')
                .replace(' 0 min', '');
        } else {
            formattedDuration = formattedDuration
                .format('d [days], h [hours], m [minutes]')
                .replace(', 0 hours', '')
                .replace(', 0 minutes', '')
                .replace('$1 days', '1 day')
                .replace('$1 hours', '1 hour')
                .replace('$1 minutes', '1 minute');
        }

        return formattedDuration;
    }
};

export default SHUtils;
